"use client";

import React from "react";
import { ArrowRight, Sparkles, Cpu, Layers } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Card } from "@/components/ui/card";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const caseStudies = [{
  id: 1,
  title: "Global Supply Chain Optimization",
  client: "Fortune 500 Retailer",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606552/img/ai_support_dashboard.png",
  tools: ["Agentic AI", "Process Mapping"],
  summary: "Modernized a legacy logistics framework for a global leader, reducing operational overhead by 15% through autonomous agent deployment and real-time auditing.",
  badge: "Global 500 Impact"
}, {
  id: 2,
  title: "SME Revenue Acceleration",
  client: "Mid-Market Manufacturing",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606552/img/inventory_prediction_chart.png",
  tools: ["Predictive Analytics", "CRM AI"],
  summary: "Empowered a $50M manufacturer to leverage enterprise-grade forecasting, resulting in a 24% increase in quarterly sales efficiency and inventory turnover.",
  badge: "SME Transformation"
}, {
  id: 3,
  title: "Financial Compliance Automation",
  client: "Tier-1 Investment Bank",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606552/img/document_parsing_ai.png",
  tools: ["NLP", "Risk Modeling"],
  summary: "Automated regulatory reporting for a global financial institution, ensuring 100% compliance accuracy while saving 12,000 man-hours of manual review annually.",
  badge: "Legacy Reform"
}, {
  id: 4,
  title: "AI Strategy Roadmap",
  client: "Regional Tech Hub",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606552/img/learning_path_ui.png",
  tools: ["Strategy Consulting", "Change Management"],
  summary: "Designed a comprehensive 3-year AI adoption roadmap, transitioning a traditional workforce to an AI-first culture with 90% staff adoption rates.",
  badge: "Future-Ready"
}, {
  id: 5,
  title: "Operational Cost Reduction",
  client: "Global Energy Corp",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606552/img/marketing_copy_generator.png",
  tools: ["Deep Learning", "Efficiency Audits"],
  summary: "Identified and eliminated systemic inefficiencies in energy distribution using custom ML models, saving the client $4.2M in annual operational waste.",
  badge: "Efficiency Peak"
}];
export default function AiInAction() {
  return;
}